const readDelayMs = (): number => {
  const raw =
    process.env.NEXT_PUBLIC_POSTHOG_SESSION_RECORDING_DELAY_MS?.trim();
  if (!raw) return 8_000;

  const parsed = Number(raw);
  return Number.isFinite(parsed) && parsed >= 0 ? parsed : 8_000;
};

/** Defer rrweb until after LCP / initial interaction window. */
export const MARKETING_SESSION_RECORDING_DELAY_MS = readDelayMs();

export const MARKETING_SESSION_RECORDING_OPTIONS = {
  maskAllInputs: true,
  maskTextSelector: "[data-ph-mask], .ph-mask",
  blockSelector: "[data-ph-no-capture]",
} as const;
